<template>
  <v-select
    v-model="selected"
    :items="activeUsers"
    item-value="id"
    :item-text="userName"
    attach
    outlined
    dense
    :clearable="clearable"
    :chips="multiple"
    label="Active Users"
    :multiple="multiple"
    menu-props="auto, overflowX, overflowY"
    @change="$emit('select-item', selected)"
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="(index === 0 || showAll) && multiple">
        <span>{{ userName(item) }}</span>
      </v-chip>
      <span v-if="!multiple">{{ userName(item) }}</span>
      <span
        v-if="index === 1 && !showAll && multiple"
        class="grey--text caption"
      >(+{{ selected.length - 1 }} others)</span>
    </template>
  </v-select>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { get } from 'lodash'

  export default {
    props: {
      multiple: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      showAll: {
        type: Boolean,
        default: false
      },
      users: {
        type: Array,
        default: () => []
      },
      user: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        selected: null
      }
    },
    computed: {
      ...mapGetters([ 'activeUsers' ])
    },
    watch: {
      users() {
        this.init()
      },
      user() {
        this.init()
      }
    },
    created() {
      /**
       * @todo This probably shouldnt be an appropriate place to init the observable.
       *        A snapshot would be fine `ensureStaff`
       */
      this.init()
      this.$store.dispatch('initUsers')
    },
    methods: {
      init() {
        this.selected = this.multiple
          ? (this.users || [])
          : (this.user || '')
      },
      userName: user => `${get(user, 'firstName', '')} ${get(user, 'lastName', '')}`.trim()
    }
  }
</script>
